module.exports = __webpack_public_path__ + "static/media/commute-img-003.9faf5db6.jpg";